/*
  Confident Care — enquiry list.

  A quote basket without a cart. Shopify's cart would have handled storage, but
  it brings checkout, price and a /cart page with it — all things this catalogue
  deliberately does not have. So the list lives in the browser (localStorage)
  and is sent through the store's own contact form, the same way the
  single-product form is. No app, no monthly fee.

  Trade-off: the list belongs to one browser. A buyer who starts on their phone
  and finishes on a desktop starts again. For a handful of products that is
  fine; if it ever is not, this is the file to replace.

  Loaded on every page from cc-header.liquid. Hooks:
    [data-cc-add]    product page block (data-id, data-title, data-variant, data-sku, data-url, data-image)
    [data-cc-count]  anything that should show the number of lines in the list
    [data-cc-list]   where the list page renders rows
    [data-cc-empty]  list page empty state
    [data-cc-field]  hidden form field the list is written into on submit
    [data-cc-sent]   present after a successful send — empties the list
*/
(function () {
  var KEY = 'cc-enquiry-v1';

  function read() {
    try {
      var l = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(l) ? l : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    badge();
  }

  function badge() {
    var n = read().length;
    document.querySelectorAll('[data-cc-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function qtyOf(v) {
    var n = parseInt(v, 10);
    return n > 0 ? n : 1;
  }

  /* Product page. The block ships hidden and is revealed here, so a browser
     without JavaScript never sees a button that does nothing. */
  document.querySelectorAll('[data-cc-add]').forEach(function (box) {
    box.hidden = false;
    var btn = box.querySelector('button');
    var qty = box.querySelector('input');
    var ok = box.querySelector('.cc-add__ok');
    var timer;
    btn.addEventListener('click', function () {
      var d = box.dataset, list = read(), n = qtyOf(qty.value), hit = null;
      list.forEach(function (i) { if (i.id === d.id) hit = i; });
      if (hit) hit.qty = qtyOf(hit.qty) + n;
      else list.push({ id: d.id, title: d.title, variant: d.variant, sku: d.sku,
                       url: d.url, image: d.image, qty: n });
      write(list);
      if (ok) ok.hidden = false;
      btn.textContent = hit ? 'Quantity updated' : 'Added to your list';
      clearTimeout(timer);
      timer = setTimeout(function () { btn.textContent = btn.dataset.label; }, 2200);
    });
  });

  /* List page. */
  var root = document.querySelector('[data-cc-list]');
  if (root) {
    if (document.querySelector('[data-cc-sent]')) write([]);

    var empty = document.querySelector('[data-cc-empty]');
    var field = document.querySelector('[data-cc-field]');
    var form = field && field.form;

    var render = function () {
      var list = read();
      root.textContent = '';
      if (empty) empty.hidden = list.length > 0;
      list.forEach(function (item, idx) {
        var row = document.createElement('div');
        row.className = 'cc-elist__row';

        var pic;
        if (item.image) {
          pic = document.createElement('img');
          pic.src = item.image;
          pic.alt = '';
          pic.loading = 'lazy';
        } else {
          pic = document.createElement('span');
          pic.className = 'cc-elist__noimg';
        }

        var t = document.createElement('div');
        t.className = 'cc-elist__t';
        var a = document.createElement('a');
        a.href = item.url;
        a.textContent = item.title;
        t.appendChild(a);
        if (item.variant) {
          var v = document.createElement('span');
          v.className = 'cc-elist__v';
          v.textContent = item.variant;
          t.appendChild(v);
        }

        var lab = document.createElement('label');
        lab.className = 'cc-vh';
        lab.htmlFor = 'cc-q' + idx;
        lab.textContent = 'Quantity for ' + item.title;

        var q = document.createElement('input');
        q.type = 'number';
        q.min = '1';
        q.inputMode = 'numeric';
        q.id = 'cc-q' + idx;
        q.className = 'cc-elist__q';
        q.value = qtyOf(item.qty);
        q.addEventListener('change', function () {
          var l = read();
          if (!l[idx]) return;
          l[idx].qty = qtyOf(q.value);
          q.value = l[idx].qty;
          write(l);
        });

        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'cc-elist__rm';
        rm.textContent = 'Remove';
        rm.addEventListener('click', function () {
          var l = read();
          l.splice(idx, 1);
          write(l);
          render();
        });

        row.appendChild(pic);
        row.appendChild(t);
        row.appendChild(lab);
        row.appendChild(q);
        row.appendChild(rm);
        root.appendChild(row);
      });
    };
    render();

    if (form) {
      form.addEventListener('submit', function () {
        field.value = read().map(function (i) {
          return qtyOf(i.qty) + ' x ' + i.title +
            (i.variant ? ' — ' + i.variant : '') +
            (i.sku ? ' (code ' + i.sku + ')' : '') +
            '\n    ' + location.origin + i.url;
        }).join('\n');
      });
    }
  }

  badge();
})();
